exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-wrap[data-v-3f64ee43]{border-bottom:1px solid #d9d9d9;font-size:13px}.deserve-score[data-v-3f64ee43]{width:66px;height:25px;line-height:25px;color:red;background-color:#d9d9d9;text-align:center}.content .exam-pointer[data-v-3f64ee43]{min-width:30px}.content .exam-pointer_corret[data-v-3f64ee43]{background-color:#09f;color:#fff}.content .exam-pointer_corret[data-v-3f64ee43],.content .exam-pointer_error[data-v-3f64ee43]{border-radius:50%;border:1px solid #d9d9d9}.content .answer[data-v-3f64ee43]{background-color:#d9d9d9;padding:2px;font-size:#000;font-size:12px;min-height:50px}", ""]);

// exports
